import { ReactNode } from "react";
import Link from "next/link";

type SummaryCardTone = "default" | "success" | "info" | "warning" | "danger";

type SummaryCardItem = {
  label: string;
  value: ReactNode;
  hint?: string;
  tone?: SummaryCardTone;
  href?: string;
};

type SummaryCardsProps = {
  items: SummaryCardItem[];
  columns?: 3 | 4 | 5;
};

const toneValueColor: Record<SummaryCardTone, string> = {
  default: "var(--foreground)",
  success: "var(--success)",
  info: "var(--info)",
  warning: "var(--warning)",
  danger: "var(--error)",
};

export function SummaryCards({ items, columns = 4 }: SummaryCardsProps) {
  const gridClass =
    columns === 5
      ? "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5"
      : columns === 3
        ? "grid-cols-2 lg:grid-cols-3"
        : "grid-cols-2 lg:grid-cols-4";

  return (
    <div className={`grid gap-3 ${gridClass}`}>
      {items.map((item) => {
        const tone = item.tone ?? "default";
        const card = (
          <div
            key={item.label}
            className={`rounded-[10px] border border-[var(--border)] bg-[var(--surface)] px-[18px] py-4${item.href ? " transition hover:border-[#E8441A]/40 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E8441A]" : ""}`}
            style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.07)" }}
          >
            <p className="mb-[6px] text-[12px] font-medium text-[var(--muted-foreground)]">
              {item.label}
            </p>
            <p
              className="text-2xl font-bold leading-none"
              style={{ color: toneValueColor[tone] }}
            >
              {item.value}
            </p>
            {item.hint ? (
              <p className="mt-1.5 text-[11.5px] text-[var(--text-muted)]">{item.hint}</p>
            ) : null}
          </div>
        );
        return item.href ? (
          <Link
            key={item.label}
            href={item.href}
            aria-label={`Abrir ${item.label}`}
            className="block rounded-[10px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E8441A]"
          >
            {card}
          </Link>
        ) : card;
      })}
    </div>
  );
}
